import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { store } from 'Store';
import { clearFields } from "Store/LoginInfoSlice";
import { useNavigate } from 'react-router-dom';
import { httpLogin } from "Utils/httpLogin";
import useBoradcast from 'Utils/useBroadcast';
import { Image, DropdownButton, Dropdown, ButtonGroup, Stack } from 'react-bootstrap';
import Avatar from 'Images/Avatar.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { STATUSES, ERROR_MESSAGES } from 'Utils/constants';
import { setGlobalErrorStatus } from 'Components/StatusHandling';
import { PATHS } from 'Utils/PagePaths';

const ProfileMenu = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { message, sendMessage } = useBoradcast("auth_channel");
  const loginInfo = useSelector(state => state.loginInfo);
  // faChevronRight or faChevronDown
  const [profileMenuExpandFlag, setProfileMenuExpandFlag] = useState(false);
  // menu items 
  const profileMenuItemList = [
    {
      text: "My Profile",
      path: "/manage/editUserProfile"
    },
    {
      text: "Reset Password",
      path: "/manage/resetUserPassword"
    },
    {
      text: "Two-Factor Authentication",
      path: "/manage/setupMfa"
    },
    // {
    //   text: "Notification Settings",
    //   path: ""
    // },
    // {
    //   text: "Profile Picture",
    //   path: "/manage/editUserProfilePicture"
    // }
  ]

  const handleProfileMenu = () => {
    setProfileMenuExpandFlag(!profileMenuExpandFlag);
  }

  const handleDirect = (path) => {
    //console.log("print out handleDirect", path);

    if (path === "") {
      return;
    }

    navigate(path);
  }

  const handleLogout = async () => {
    const res = await logout();

    navigate(PATHS.public['Sign In']);
  }

  // api to logout
  const logout = async () => {

    for (let i = 0; i <= sessionStorage.getItem("validateAccessInterval"); i++) {
      window.clearInterval(i);
    }

    const res = httpLogin.post('/auth/logout', {}, {
      headers: {
        "Authorization": "Bearer " + loginInfo.token
      }
    }).then(() => {
      dispatch(clearFields(loginInfo.initialState));
      //console.log("set logout from the auth channel", sessionStorage.getItem("validateAccessInterval"));
      sendMessage({
        token: "Bearer " + loginInfo.token,
        status: STATUSES.LOG_OUT.text
      });
    }).catch(function (error) {
      return error.response;
    });

    return res;
  }

  // api to validate token
  const validateAccess = async (token) => {

    const url = "/api/validation";

    const res = await httpLogin.post(url, {}, {
      headers: {
        "Authorization": token
      }
    })

    return res;
  }

  useEffect(() => {
    if (message?.status == STATUSES.LOG_OUT.text) {
      //console.log("Start validation from auth channel", message);
      if (store.getState().loginInfo?.token) {
        let tokenAuth = "Bearer " + store.getState().loginInfo.token;

        for (let i = 0; i <= sessionStorage.getItem("validateAccessInterval"); i++) {
          window.clearInterval(i);
        }

        validateAccess(tokenAuth)
          .then((res) => {
            //console.log("validateAccess profileMenu", tokenAuth);
          }).catch((error) => {
            //console.log("validateAccess profileMenu", error);
            setGlobalErrorStatus({
              dispatch: dispatch,
              popupData: {
                visible: true,
                title: ERROR_MESSAGES.DATA_ERROR.title,
                msg: ERROR_MESSAGES.DATA_ERROR.message,
                showContactHelp: true
              },
              redirect: {
                redirect: false,
                redirectFirst: false,
                path: "",
                data: {}
              },
              error: error
            });
          })
      }
    }
  }, [message])

  return (
    <div className="me-1 d-inline-block" >
      <DropdownButton
        //as={ButtonGroup}
        className=""
        id={"profileMenu"}
        variant={"bg-white"}
        onToggle={handleProfileMenu}
        title={<>
          <Image alt="Avatar" src={Avatar} />
          &nbsp;&nbsp;
          {profileMenuExpandFlag ?
            <FontAwesomeIcon className="profileMenuIcon" style={{ "color": "white" }} icon={faChevronRight} /> :
            <FontAwesomeIcon className="profileMenuIcon" style={{ "color": "white" }} icon={faChevronDown} />
          }
        </>}
        //size="lg"
        align="end"
      >
        <Dropdown.Item eventKey="1" className='bg-transparent disabled'>
          <Stack direction="horizontal" gap={3} className='userProfileInfo'>
            <div className="ps-2">
              <span className='userName'>{loginInfo.firstName}&nbsp;{loginInfo.lastName}</span>
              <br />
              <span className='userEmail'>{loginInfo.username}</span>
            </div>
            <div className='userIcon'><Image alt="" src={Avatar} />&nbsp; <FontAwesomeIcon className="profileMenuIcon" icon={faChevronRight} /></div>
          </Stack>
          <div><span className='psoName ps-2'>{loginInfo.psoName}</span></div>
        </Dropdown.Item>
        <Dropdown.Divider />
        {/**Loop menu items */}
        {profileMenuItemList.map((item, index) => (
          <Dropdown.Item eventKey={index + 1} className='userProfileItem' onClick={() => handleDirect(item.path)}><div className='p-2'>{item.text}</div></Dropdown.Item>
        ))}
        <Dropdown.Divider />
        <Dropdown.Item eventKey="7" className='userProfileItem' onClick={handleLogout}><div className='p-2'>Sign out</div></Dropdown.Item>
      </DropdownButton>
    </div>
  )
}

export default ProfileMenu;